import React from "react";
import { Heart } from "lucide-react";

/** Slow editorial marquee. Words separated by rose heart glyphs. */
export const Marquee = ({ words = [], className = "" }) => {
  const run = (
    <div className="marquee-track" aria-hidden="true">
      {[0, 1].map((k) => (
        <span key={k} className="inline-flex items-center">
          {words.map((w, i) => (
            <span key={`${k}-${i}`} className="inline-flex items-center">
              <span
                className="font-display"
                style={{ fontSize: "clamp(1.8rem,4vw,3.2rem)", color: "var(--parchment)", padding: "0 1.5rem", opacity: 0.9 }}
              >
                {w}
              </span>
              <Heart size={20} fill="var(--rose)" color="var(--rose)" style={{ margin: "0 .5rem" }} />
            </span>
          ))}
        </span>
      ))}
    </div>
  );
  return (
    <div className={`overflow-hidden ${className}`} style={{ borderBlock: "var(--rule)", paddingBlock: "var(--s3)" }}>
      {run}
    </div>
  );
};
